import { PREDEFINED_TENANTS } from 'swag-common/constants/main-swag.constants';
import { COUNTRY_CODES } from 'swag-common/constants/shipping.constants';
export const SENDOSO = 'sendoso';
export const POSTAL = 'postal';
export let TenantVisibility = /*#__PURE__*/function (TenantVisibility) {
  TenantVisibility["SENDOSO"] = "sendoso";
  TenantVisibility["SWAG"] = "swag";
  TenantVisibility["POSTAL"] = "postal";
  TenantVisibility["DYNAMIC"] = "dynamic";
  return TenantVisibility;
}({});
export const TENANT_VISIBILITY_OPTIONS = [TenantVisibility.SWAG, TenantVisibility.SENDOSO, TenantVisibility.POSTAL, TenantVisibility.DYNAMIC];
export const ADDRESS_FOR_DRAFT = {
  [PREDEFINED_TENANTS.SWAG]: ['Swag.com', 'Attention: Joshua Orbach', '1640 Boro Place', 'Suite 301', '', 'Tysons, VA, 22102'],
  [PREDEFINED_TENANTS.SENDOSO]: ['Sendoso', '6900 E Camelback Rd.', 'Suite 1100', 'Scottsdale, AZ. 85251', COUNTRY_CODES.US, 'invoices@sendoso.com'],
  [PREDEFINED_TENANTS.POSTAL]: ['Postal', '75 South Higuera St.', 'Suite 240.', 'San Luis Obispo, CA 93401', COUNTRY_CODES.US, 'invoices@postal.com']
};
export const ADDRESS_FOR_INVOICE = {
  [PREDEFINED_TENANTS.SWAG]: ['Swag.com', '1640 Boro Place', 'Suite 301', 'Tysons, VA, 22102'],
  [PREDEFINED_TENANTS.SENDOSO]: ['Sendoso', '6900 E Camelback Rd.', 'Suite 1100', 'Scottsdale, AZ. 85251', COUNTRY_CODES.US, 'invoices@sendoso.com'],
  [PREDEFINED_TENANTS.POSTAL]: ['Postal', '75 South Higuera St.', 'Suite 240.', 'San Luis Obispo, CA 93401', COUNTRY_CODES.US, 'invoices@postal.com']
};
export const OFFICE_ADDRESS_DRAFT = {
  [PREDEFINED_TENANTS.SWAG]: 'Registered Office: Attention: Joshua Orbach, 1640 Boro Place, Suite 301, Tysons, VA, 22102.',
  [PREDEFINED_TENANTS.SENDOSO]: 'Registered Office: 6900 E Camelback Rd. Suite 1100 Scottsdale, AZ. 85251, United States.',
  [PREDEFINED_TENANTS.POSTAL]: 'Registered Office: 75 South Higuera St.Suite 240. San Luis Obispo, CA 93401 US.'
};
export const OFFICE_ADDRESS_INVOICE = {
  [PREDEFINED_TENANTS.SWAG]: 'Registered Office: 1640 Boro Place, Suite 301, Tysons, VA, 22102.',
  [PREDEFINED_TENANTS.SENDOSO]: 'Registered Office: 6900 E Camelback Rd. Suite 1100 Scottsdale, AZ. 85251, United States.',
  [PREDEFINED_TENANTS.POSTAL]: 'Registered Office: 75 South Higuera St.Suite 240. San Luis Obispo, CA 93401 US.'
};
export const PO_SHIPNOTICE_MSG = 'Important: Each carton must have a shipping label and Ship Notice either printed on it or affixed to it, in a location and condition that is easily visible and scannable.';
export const FullyCustomizedTenantApps = [SENDOSO, POSTAL];